<div class="verification-page">
    <div class="container d-flex">
        <div class="info-content">
            <div class="info">
                <div class="portalLogo"></div>
                <h2 class="my-5">
                    {{user?.status === 'provisioning' ? 'Is This You?' : 'AFP Account Information'}}
                </h2>
                <p *ngIf="user?.status === 'provisioning'">If so press continue.</p>
            </div>
            <div class="contacts">
                <p class="m-0">Contact us:</p>
                <div>
                    <a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                        AFPsupport@mcgriff.com
                    </a>
                    <span></span>
                    <a href="tel:+18448186243">844-818-6243</a>
                </div>
            </div>
            <div class="footer mt-2">
                <a
                    href="https://www.marshmma.com/us/privacy-notice.html"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Notice
                </a>
            </div>
        </div>
        <div class="main-content">
            <div class="form">
                <form (ngSubmit)="onSubmit()" #form="ngForm">
                    <div class="form-group">
                        <input class="form-input" name="userName" type="text" id="welcome-user-name"
                            [ngModel]="user && user.verificationInfo.userName"
                            [disabled]="true"
                            placeholder="User Name" required/>
                        <label for="welcome-user-name" class="form_label">User Name</label>
                    </div>
                    <div class="form-group">
                        <input class="form-input" name="phone" type="tel" id="welcome-phone"
                            [ngModel]="user && user.verificationInfo.userPhone"
                            placeholder="Mobile Phone"
                            [disabled]="true"
                            required/>
                        <label for="welcome-phone" class="form_label">Mobile Phone</label>
                    </div>
                    <div class="form-group">
                        <input class="form-input" name="insuredName" type="text" id="ver-insured-name"
                            [ngModel]="user && user.verificationInfo.insuredName" placeholder="Insured Name"
                            [disabled]="true" required/>
                        <label for="ver-insured-name" class="form_label">Insured Name</label>
                    </div>
                    <div class="form-group">
                        <input class="form-input" name="amazonScacCode" type="text" id="ver-amazon-scac-code"
                            [ngModel]="user && user.verificationInfo.amazonScacCode" placeholder="Amazon SCAC Code"
                            [disabled]="true" required/>
                        <label for="ver-amazon-scac-code" class="form_label">Amazon SCAC Code</label>
                    </div>
                    <div class="form-group">
                        <input class="form-input" name="amazonDotNumber" type="text" id="ver-amazon-dot-number"
                            [ngModel]="user && user.verificationInfo.amazonDotNumber" [disabled]="true"
                            placeholder="Department of Transportation (DOT) Number" required/>
                        <label for="ver-amazon-dot-number" class="form_label">Department of Transportation (DOT) Number</label>
                    </div>
                    <p class="text-center"><a href="mailto:AFPsupport@mcgriff.com?subject={{user?.verificationInfo?.insuredName ? user?.verificationInfo?.insuredName : ''}}">
                        Report
                    </a>
                        incorrect information
                    </p>
                </form>
            </div>
            <div class="actions pt-3" [ngClass]="{'text-end' : user?.status === 'provisioning'}">
                <button (click)="onSubmit()" class="primary-button">
                   {{user?.status === 'provisioning' ? 'Continue' : 'Go back'}}
                </button>
            </div>
        </div>
    </div>
</div>
